import React from 'react';
import Button from '../Button';
import styles from './job-card.module.scss';
import {useTranslation} from "react-i18next";

const JobCard = ({ className, data }) => {
  const { title, slug, short_description } = data;

  const [t, i18n] = useTranslation("global");

  const descriptionCutter = (desc, length) => {
    const descArr = desc.split(' ');
    return descArr.length > length ? [...descArr.slice(0, length), '...'].join(' ') : desc;
  }

  return (
    <div className={`${styles.wrapper} ${className && className}`}>
      <h4 className={styles.title}>{ title }</h4>
      <div
        className={styles.desc}
        dangerouslySetInnerHTML={{ __html: descriptionCutter(short_description, 30)}}
      />
      <div className={styles.img}></div>
      <Button
        className={styles.button}
        type={'link'}
        view={'small'}
        text={t("buttons.more")}
        to={`/jobs/${slug}`}
      />
    </div>
  );
};

export default JobCard;